import { render } from "./StoragePlan.vue?vue&type=template&id=770cddb2"
import script from "./StoragePlan.vue?vue&type=script&lang=js"
export * from "./StoragePlan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__